import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { WagmiProvider } from 'wagmi'
import { RainbowKitProvider } from '@rainbow-me/rainbowkit'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { getDefaultConfig } from '@rainbow-me/rainbowkit'
import { defineChain } from 'viem'
import { lazy, Suspense } from 'react'
import '@rainbow-me/rainbowkit/styles.css'
import Layout from '@/components/Layout'
import Home from '@/pages/Home'
import Games from '@/pages/Games'
import Facts from '@/pages/Facts'
import NotFound from '@/pages/NotFound'
import IdentityMint from '@/pages/IdentityMint'
import ParrotSave from '@/games/parrotsave'
import ParrotJump from '@/games/parrotjump'
import ParrotCart from '@/games/parrotcart'
import ParrotVsSnakes from '@/games/parrotvssnakes'
import TokenCreator from './pages/TokenCreator'
import PlayerProvider from '@/providers/PlayerProvider'
import Leaderboard from '@/pages/Leaderboard'
import HolderScore from '@/pages/HolderScore'
import SquadArena from '@/pages/SquadArena'
import SquadChecker from './pages/SquadChecker'

const BotiPage = lazy(() => import('@/boti/BotiPage'))

const monad = defineChain({
  id: 143,
  name: 'Monad',
  nativeCurrency: { name: 'MON', symbol: 'MON', decimals: 18 },
  rpcUrls: {
    default: { http: ['https://rpc.monad.xyz'] },
  },
  blockExplorers: {
    default: { name: 'MonadScan', url: 'https://explorer.monad.xyz' },
  },
})

const config = getDefaultConfig({
  appName: '10k Squad Bot',
  projectId: '4bd86788e679f08c9e93dabe5c02a928',
  chains: [monad],
})

const queryClient = new QueryClient()

export default function App() {
  return (
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <RainbowKitProvider>
          <BrowserRouter>
            <Routes>

              {/* ── Main site (with navbar/footer layout) ── */}
              <Route path="/" element={<Layout />}>
                <Route index element={<Home />} />
                <Route path="facts" element={<Facts />} />
                <Route path="identity" element={<IdentityMint />} />
                <Route path="tokens" element={<TokenCreator />} />
                <Route path="score" element={<HolderScore />} />
                <Route path="*" element={<NotFound />} />
                <Route path="arena" element={<SquadArena />} />
                <Route path="squad-checker" element={<SquadChecker />} />
              </Route>

              {/* ── Boti AI Parrot (full-screen, no navbar/footer) ── */}
              <Route
                path="/boti"
                element={
                  <Suspense fallback={<div style={{ background: '#0a0008', minHeight: '100vh' }} />}>
                    <BotiPage />
                  </Suspense>
                }
              />

              {/* ── Games hub ── */}
              <Route
                path="/games"
                element={
                  <PlayerProvider>
                    <Games />
                  </PlayerProvider>
                }
              />

              {/* ── Individual game routes ── */}
              <Route
                path="/games/save"
                element={
                  <PlayerProvider>
                    <ParrotSave />
                  </PlayerProvider>
                }
              />
              <Route
                path="/games/jump"
                element={
                  <PlayerProvider>
                    <ParrotJump />
                  </PlayerProvider>
                }
              />
              <Route
                path="/games/cart"
                element={
                  <PlayerProvider>
                    <ParrotCart />
                  </PlayerProvider>
                }
              />
              <Route
                path="/games/znakes"
                element={
                  <PlayerProvider>
                    <ParrotVsSnakes />
                  </PlayerProvider>
                }
              />
              <Route
                path="/games/scores"
                element={
                  <PlayerProvider>
                    <Leaderboard />
                  </PlayerProvider>
                }
              />

            </Routes>
          </BrowserRouter>
        </RainbowKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  )
}